module.exports = __webpack_public_path__ + "static/media/5-seo-new.b9cbec42.png";